import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceText',
    standalone: false
})
export class ReplaceTextPipe implements PipeTransform {
	transform(
		originalString: string,
		textToBeReplaced: string,
		textToInsert: string
	): any {
		const updatedString: string =
			originalString
				?.replace(
					new RegExp(this.escapeRegExp(textToBeReplaced), 'gi'),
					textToInsert
				);

		return updatedString ?? originalString;
	}

	escapeRegExp(text: string): string {
		return text
			.replace(
				/[-[\]{}()*+?.,\\^$|#\s]/g,
				'\\$&'
			);
	}
}
